<template>
  <div>
    <div class="solution">
    <img src="@/assets/image/Slice 28@3x(1).png" alt="" class="home-bg">
      <header-component  pageType="solution-write" :menuIndex="1"/>
      <nav class="w-1000">
        <div class="nav-txt" data-aos="fade-up"><div class="txt1">{{ $t('solution1.nav.oneStop') }}</div>{{ $t('solution1.nav.register') }}</div>
        <div class="nav-txt" data-aos="fade-up" data-aos-delay="100" data-aos-offset="300">{{ $t('solution1.nav.easyStart') }}</div>
        <div class="desc" data-aos="fade-up" data-aos-delay="200" data-aos-offset="300">{{ $t('solution1.nav.desc') }}</div>
        <div class="btn" data-aos="fade-up" data-aos-delay="300" data-aos-offset="300" @click="$refs.connectRef.toConnectIndex()">{{ $t('solution1.nav.btn') }}</div>
      </nav>
      <div class="content1 w-1000 flex flex-column flex-align-center">
        <div class="txt1">{{ $t('solution1.modules.num') }}</div>
        <div class="txt2">{{ $t('solution1.modules.title') }}</div>
        <img src="@/assets/image/solution1/Slice 34@2x.png" class="down"/>
        <div class="item flex flex-align-center flex-justify-between">
          <img src="@/assets/image/solution1/Slice 35@2x.png"  data-aos="fade-up"/>
          <div class="flex flex-column">
            <div class="title"  data-aos="fade-up" data-aos-delay="100">{{ $t('solution1.modules.card1.title') }}</div>
            <div class="desc"  data-aos="fade-up" data-aos-delay="200" v-html="$t('solution1.modules.card1.desc')"></div>
            <div class="txt"  data-aos="fade-up" data-aos-delay="300">{{ $t('solution1.modules.card1.link') }}</div>
          </div>
        </div>
        <div class="item flex flex-align-center flex-justify-between">
          <div class="flex flex-column">
            <div class="title"  data-aos="fade-up" data-aos-delay="100">{{ $t('solution1.modules.card2.title') }}</div>
            <div class="desc"  data-aos="fade-up" data-aos-delay="200" v-html="$t('solution1.modules.card2.desc')"></div>
            <div class="txt"  data-aos="fade-up" data-aos-delay="300">{{ $t('solution1.modules.card2.link') }}</div>
          </div>
          <img src="@/assets/image/solution1/Slice 38@2x(1).png"   data-aos="fade-up"/>
        </div>
        <div class="item flex flex-align-center flex-justify-between">
          <img src="@/assets/image/solution1/Slice 38@2x.png"   data-aos="fade-up"/>
          <div class="flex flex-column">
            <div class="title"   data-aos="fade-up">{{ $t('solution1.modules.card3.title') }}</div>
            <div class="desc"   data-aos="fade-up" v-html="$t('solution1.modules.card3.desc')"></div>
            <div class="txt"   data-aos="fade-up">{{ $t('solution1.modules.card3.link') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="question-nav w-1000">
      <h1>{{ $t('solution1.faq.title') }}</h1>
      <div class="item" v-for="(item, index) in questionList" :key="index">
        <div class="top flex flex-justify-between flex-align-center" @click="toggleQuestion(index)">
          <div class="title">{{ $t(item.title) }}</div>
          <img src="@/assets/image/solution1/Slice 36@2x.png" v-if="!item.status"/>
          <img src="@/assets/image/solution1/Slice 36@2x(1).png" v-else/>
        </div>
        <div class="desc" v-if="item.status" data-aos="fade">{{ $t(item.value) }}</div>
      </div>
    </div>
    <connect-component ref="connectRef"></connect-component>
    <kf-component kf-top="1103px" ref="kfContainer"></kf-component>
  </div>
</template>
<script>
export default {
  name: 'solution1-page',
  data() {
    return {
      questionList: [
        {
          title: 'solution1.faq.q1',
          value: 'solution1.faq.a1',
          status: false,
        },
        {
          title: 'solution1.faq.q2',
          value: 'solution1.faq.a2',
          status: false,
        },
        {
          title: 'solution1.faq.q3',
          value: 'solution1.faq.a3',
          status: false,
        }
      ]
    }
  },
  methods: {
    toggleQuestion(index) {
      this.questionList[index].status = !this.questionList[index].status;
    }
  }
}
</script>
<style lang="less" scoped>
.home-bg{
  width:100vw;position:absolute;top:90px;left:0;z-index:0;}
.solution{
  min-height: 2516px;
  background: linear-gradient( 180deg, #0B0B0F 44%, #2D2D6B 89%, #5448B2 98%);
  border-radius: 0px 0px 0px 0px;
  padding-bottom: 100px;
}
nav {
  padding-top: 290px;
  position: relative;
  .nav-txt {
    font-weight: bold;
    font-size: 60px;
    color: #FFFFFF;
    line-height: 90px;
    text-align: left;
    .txt1{
      color: #C085FF;
      display: inline-block;
    }
  }
  .desc{
    width: 663px;
    font-family: Inter, Inter;
    font-weight: 500;
    font-size: 20px;
    color: #8C898E;
    line-height: 40px;
    margin-top: 14px;
  }

  .btn {
    width: 196px;
    height: 46px;
    line-height: 46px;
    background: #FFFFFF;
    border-radius: 50px 50px 50px 50px;
    font-weight: bold;
    font-size: 16px;
    color: #6D7EEA;
    text-align: center;
    margin-top: 20px;
    letter-spacing: 3px;
    cursor: pointer;
  }
}
.content1{
  position: relative;
  margin: 340px auto 0;
  .txt1{
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 200px;
    text-shadow: inset 4px 4px 8px rgba(255,255,255,0.3), inset -4px -3px 6px rgba(255,255,255,0.25);
    text-align: left;
    font-style: normal;
    text-transform: none;
    background: linear-gradient(90deg, #BC49FF 0%, #7AF6FF 51%, #9175FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .txt2{
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 60px;
    color: #FFFFFF;
    margin: 0 0 44px;
  }
  .down{
    width: 61px;
    height: 61px;
    margin-bottom: 119px;
  }
  .item{
    padding: 40px 20px;
    min-height: 250px;
    box-sizing: border-box;
    img{
      width: 200px;
      margin-right: 48px;
    }
    .title{
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 30px;
      color: #FFFFFF;
      line-height: 26px;
    }
    .desc{
      font-family: Inter, Inter;
      font-weight: 500;
      font-size: 17px;
      color: #ADADAD;
      line-height: 26px;
      margin: 38px 0 26px;
    }
    .txt{
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 5px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      background: linear-gradient(1.5327782102239949deg, #B46FFF 0%, #646CFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}

.question-nav{
  margin: 112px auto;
  h1{
    margin: 0 auto 70px;
    text-align: center;
    font-weight: bold;
  }
  .item{
    background: #FAFAFA;
    border-radius: 10px 10px 10px 10px;
    padding: 0 26px 0 30px;
    margin-bottom: 20px;
    .top{
      height: 97px;
      background: #FAFAFA;
      border-radius: 10px 10px 10px 10px;
      cursor: pointer;
      .title{
        font-family: Inter, Inter;
        font-weight: 500;
        font-size: 20px;
        color: #000000;
        line-height: 20px;
      }
      img{
        width: 56px;
        height: 56px;
        cursor: pointer;
      }
    }
    .desc{
      width: 621px;
      font-family: Inter, Inter;
      font-weight: 500;
      font-size: 16px;
      color: #51545A;
      line-height: 50px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      padding-bottom: 50px;
    }
  }
}
</style>